import { combineReducers } from 'redux';
import userReducer from './user';
import gamesReducer from './games';
import umpireReducer from './umpires';
import organizationsReducer from './organizations';
import divisionsReducer from './divisions';
import seasonsReducer from './seasons';
import teamsReducer from './teams';
import listsReducer from './lists';
import errorsReducer from './errors';
import reportReducer from './reports';
import mobileReducer from './mobile';
import weatherReducer from './weather';
import smsReducer from './sms';

const rootReducer = combineReducers({
  user: userReducer,
  games: gamesReducer,
  umpires: umpireReducer,
  organizations: organizationsReducer,
  divisions: divisionsReducer,
  seasons: seasonsReducer,
  teams: teamsReducer,
  lists: listsReducer,
  errors: errorsReducer,
  reports: reportReducer,
  mobile: mobileReducer,
  weather: weatherReducer,
  sms: smsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js